// @ts-nocheck
import { SVGContainer, TLBounds, Utils } from "@tldraw/core";
import { intersectBoundsPolygon, intersectLineSegmentPolyline, intersectRayLineSegment } from "@tldraw/intersect";
import Vec from "@tldraw/vec";
import { BINDING_DISTANCE, GHOSTED_OPACITY } from "pages/flyer/builder/drawer/constants/constants";
import {
  defaultHexagonStyle,
  defaultStyle,
  getBoundsRectangle,
  transformRectangle,
  transformSingleRectangle,
} from "pages/flyer/builder/drawer/state/shapes/shared";
import { styled } from "pages/flyer/builder/drawer/styles";
import { DashStyle, HexagonShape, TDMeta, TDShape, TDShapeType } from "pages/flyer/builder/drawer/types";
import { TDShapeUtil } from "../TDShapeUtil";
import { DashedHexagon } from "./components/DashedHexagon";
import { DrawHexagon } from "./components/DrawHexagon";
import { HexagonBindingIndicator } from "./components/HexagonBindingIndicator";
import { getHexagonCentroid, getHexagonIndicatorPathTDSnapshot, getHexagonPoints } from "./hexagonHelpers";

type T = HexagonShape;
type E = HTMLDivElement;

export class HexagonUtil extends TDShapeUtil<T, E> {
  type = TDShapeType.Hexagon as const;

  canBind = true;

  canClone = true;

  canEdit = false;

  getShape = (props: Partial<T>): T => {
    return Utils.deepMerge<T>(
      {
        id: "id",
        type: TDShapeType.Hexagon,
        name: "Hexagon",
        parentId: "page",
        childIndex: 1,
        point: [0, 0],
        size: [1, 1],
        rotation: 0,
        style: defaultHexagonStyle,
        label: "",
        labelPoint: [0.5, 0.5],
      },
      props
    );
  };

  Component = TDShapeUtil.Component<T, E, TDMeta>(
    ({ shape, isBinding, isSelected, isGhost, meta, events, onShapeChange }, ref) => {
      const { id, size, style } = shape;
      const Component = style.dash === DashStyle.Draw ? DrawHexagon : DashedHexagon;

      return (
        <FullWrapper ref={ref} {...events}>
          <SVGContainer
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
            id={shape.id + "_svg"}
            opacity={isGhost ? GHOSTED_OPACITY : 1}
          >
            {isBinding && <HexagonBindingIndicator size={size} />}
            <Component id={id} style={style} size={size} isSelected={isSelected} isDarkMode={meta.isDarkMode} />
          </SVGContainer>
        </FullWrapper>
      );
    }
  );

  Indicator = TDShapeUtil.Indicator<T>(({ shape }) => {
    const { id, style, size } = shape;

    if (style.dash === DashStyle.Draw) {
      return <path d={getHexagonIndicatorPathTDSnapshot(id, size, style)} />;
    }

    return <polygon points={getHexagonPoints(size).join()} />;
  });

  // private getPoints(shape: T) {
  //   const {
  //     rotation = 0,
  //     point: [x, y],
  //     size: [w, h],
  //   } = shape;
  //   const hexagonPoints = getHexagonPoints([w, h]);
  //   return hexagonPoints.map((pt) => Vec.rotWith(Vec.add(pt, [x, y]), this.getCenter(shape), rotation));
  // }

  getBounds = (shape: T) => {
    return getBoundsRectangle(shape, this.boundsCache);
  };

  shouldRender = (prev: T, next: T) => {
    return next.size !== prev.size || next.style !== prev.style || next.label !== prev.label;
  };

  // getExpandedBounds = (shape: T) => {
  //   return Utils.getBoundsFromPoints(
  //     getHexagonPoints(shape.size, this.bindingDistance).map((pt) => Vec.add(pt, shape.point))
  //   );
  // };

  // hitTestLineSegment = (shape: T, A: number[], B: number[]): boolean => {
  //   return intersectLineSegmentPolyline(A, B, this.getPoints(shape)).didIntersect;
  // };

  // hitTestBounds = (shape: T, bounds: TLBounds): boolean => {
  //   return (
  //     Utils.boundsContained(this.getBounds(shape), bounds) ||
  //     intersectBoundsPolygon(bounds, this.getPoints(shape)).length > 0
  //   );
  // };

  // getBindingPoint = <K extends TDShape>(
  //   shape: T,
  //   fromShape: K,
  //   point: number[],
  //   origin: number[],
  //   direction: number[],
  //   bindAnywhere: boolean
  // ) => {
  //   const expandedBounds = this.getExpandedBounds(shape);

  //   if (!Utils.pointInBounds(point, expandedBounds)) return;

  //   const points = getHexagonPoints(shape.size).map((pt) => Vec.add(pt, shape.point));

  //   const expandedPoints = getHexagonPoints(shape.size, this.bindingDistance).map((pt) => Vec.add(pt, shape.point));

  //   const closestDistanceToEdge = Utils.pointsToLineSegments(points, true)
  //     .map(([a, b]) => Vec.distanceToLineSegment(a, b, point))
  //     .sort((a, b) => a - b)[0];

  //   if (!(Utils.pointInPolygon(point, expandedPoints) || closestDistanceToEdge < this.bindingDistance)) return;

  //   const intersections = Utils.pointsToLineSegments(expandedPoints.concat([expandedPoints[0]]))
  //     .map((segment) => intersectRayLineSegment(origin, direction, segment[0], segment[1]))
  //     .filter((intersection) => intersection.didIntersect)
  //     .flatMap((intersection) => intersection.points);

  //   if (!intersections.length) return;

  //   const center = Vec.add(getHexagonCentroid(shape.size), shape.point);

  //   const intersection = intersections.sort((a, b) => Vec.dist(b, origin) - Vec.dist(a, origin))[0];

  //   const middlePoint = Vec.med(point, intersection);

  //   let anchor: number[];
  //   let distance: number;

  //   if (bindAnywhere) {
  //     anchor = Vec.dist(point, center) < BINDING_DISTANCE / 2 ? center : point;
  //     distance = 0;
  //   } else {
  //     if (Vec.distanceToLineSegment(point, middlePoint, center) < BINDING_DISTANCE / 2) {
  //       anchor = center;
  //     } else {
  //       anchor = middlePoint;
  //     }

  //     if (Utils.pointInPolygon(point, points)) {
  //       distance = this.bindingDistance;
  //     } else {
  //       distance = Math.max(this.bindingDistance, closestDistanceToEdge);
  //     }
  //   }

  //   const bindingPoint = Vec.divV(Vec.sub(anchor, [expandedBounds.minX, expandedBounds.minY]), [
  //     expandedBounds.width,
  //     expandedBounds.height,
  //   ]);

  //   return {
  //     point: Vec.clampV(bindingPoint, 0, 1),
  //     distance,
  //   };
  // };

  transform = transformRectangle;

  transformSingle = transformSingleRectangle;
}

const FullWrapper = styled("div", { width: "100%", height: "100%" });
